import React from "react";
import { me } from "../assets";

const About = () => {
    return <section className="about" id="about">
        <img src={me.src} alt={me.alt} />
        <div className="about-text">
            <h1>Bianca-Ștefana Popa</h1>

            <p>Welcome to my portfolio.</p>
            <p>I am a full stack developer specializing in .NET, with experience delivering software solutions throughout the entire development lifecycle.</p>
            <p>My approach combines ambition, creativity, and strong communication skills.</p>
            <p>This portfolio presents a selection of my projects, highlighting my skills, hobbies, and passion for technology.</p>
        </div>
    </section>;
};

export default About;
